import { instance } from './instance';
import type {
  IScheduledPaymentRequest,
  IScheduledPaymentRequestListParams,
  IScheduledPaymentRequestListResponse,
} from '../types';

const BASE = '/admin/company-scheduled-payments';

export const scheduledPaymentRequestsApi = {
  list: async (
    params: IScheduledPaymentRequestListParams,
  ): Promise<IScheduledPaymentRequestListResponse> =>
    (await instance.get(BASE, { params })).data,

  approve: async (id: string): Promise<IScheduledPaymentRequest> => {
    const { data } = await instance.post(`${BASE}/${id}/approve`, {});
    return (data?.data ?? data) as IScheduledPaymentRequest;
  },

  decline: async (
    id: string,
    reason?: string,
  ): Promise<IScheduledPaymentRequest> => {
    const body = reason ? { reason } : {};
    const { data } = await instance.post(`${BASE}/${id}/decline`, body);
    return (data?.data ?? data) as IScheduledPaymentRequest;
  },
};
